import React from "react";
import {contactImportApi} from '../../requests/api';
import SlicedUploadTab, {Stat, noteLine, subjectLine} from './SlicedUploadTab';

const REPORT_COLUMNS = ['Row', 'Name', 'Outcome', 'Reason', 'Investor ID', 'Notes'];

const reportRow = (item) => [
    item.external_id,
    subjectLine(item),
    item.outcome,
    item.reason,
    item.investor_id,
    (item.notes || []).slice(1).map(noteLine).join(' | '),
];

const stats = (run, notes, dryRun) => (
    <React.Fragment>
        <div className='result-stats'>
            <Stat value={notes.total_rows} label='Total Rows'/>
            <Stat value={notes.found_in_kore} label='Found In Kore'/>
            <Stat value={notes.repeated_in_file} label='Same As An Earlier Row'/>
            <Stat value={run.created} label={dryRun ? 'Would Add' : 'Added'} tone='success'/>
            <Stat value={run.skipped} label='Left Out' tone='warning'/>
            {run.failed > 0 && <Stat value={run.failed} label='Errors' tone='error'/>}
        </div>

        <div className='result-stats'>
            <Stat value={notes.notes_written} label={dryRun ? 'Notes To Write' : 'Notes Written'}/>
            <Stat value={notes.details_noted} label='Phones Or Emails Kore Lacked'/>
            <Stat value={notes.nothing_new} label='Nothing New'/>
            {notes.values_rejected > 0 && <Stat value={notes.values_rejected} label='Values Rejected' tone='error'/>}
        </div>
    </React.Fragment>
);

/**
 * The Contacts tab: a file of people. Someone Kore already holds gets one
 * note — the row's notes and any phone or email Kore lacks — and nothing else;
 * anyone else is added with everything the row says.
 */
const UploadContactsTab = () => (
    <SlicedUploadTab
        api={contactImportApi}
        title='Upload Contacts'
        instructions={
            <p>Each person is looked up in Kore by name, phone, email, company and address. Someone
            Kore already holds gets one note with the row&rsquo;s notes and any phone or email Kore
            doesn&rsquo;t have; anyone else is added as a new investor with the row&rsquo;s details and notes.</p>
        }
        stats={stats}
        reportColumns={REPORT_COLUMNS}
        reportRow={reportRow}
        canCancel={true}
    />
);

export default UploadContactsTab;
